var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.79 68.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2,.cls-3{fill:#d7a44c;}.cls-4{fill:#0b60ab;}.cls-5{fill:#1a75bb;}.cls-3{mix-blend-mode:multiply;opacity:.3;}.cls-6{fill:url(#linear-gradient-2);mix-blend-mode:soft-light;}.cls-7{fill:#1c75bb;mix-blend-mode:screen;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 39.64,
    y1: 44.49,
    x2: 92.79,
    y2: 44.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b75bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 76.12,
    y1: 59.36,
    x2: 76.12,
    y2: 67.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 34.47,
    x2: 27.56,
    y2: 34.47,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.09,48.54c-3.87,3.83-8.57,5.74-14.11,5.74s-10.25-1.91-14.11-5.74c-3.87-3.83-5.8-8.55-5.8-14.17s1.93-10.34,5.8-14.17c3.87-3.83,8.57-5.74,14.11-5.74s10.25,1.91,14.11,5.74c3.87,3.83,5.8,8.55,5.8,14.17s-1.93,10.34-5.8,14.17Zm-22.07-5.96c2.13,2.12,4.79,3.17,7.96,3.17s5.83-1.06,7.96-3.17,3.2-4.85,3.2-8.21-1.07-6.09-3.2-8.21c-2.13-2.11-4.79-3.17-7.96-3.17s-5.83,1.06-7.96,3.17c-2.13,2.12-3.2,4.85-3.2,8.21s1.07,6.09,3.2,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,25.4c2.92,0,5.35,1,7.3,3.01,1.95,2.01,2.93,4.78,2.93,8.32v16.79h-8.21v-15.59c0-1.6-.45-2.83-1.34-3.69-.89-.86-2.03-1.29-3.42-1.29-1.57,0-2.81,.47-3.72,1.42-.91,.95-1.37,2.35-1.37,4.21v14.93h-8.21V26.16h8.21v2.57c1.64-2.22,4.25-3.34,7.82-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.77,43.12c.95,2.55,3.14,3.83,6.56,3.83,2.22,0,3.97-.69,5.25-2.08l6.56,3.77c-2.7,3.76-6.67,5.63-11.93,5.63-4.6,0-8.27-1.37-11.02-4.1-2.75-2.74-4.13-6.18-4.13-10.34s1.36-7.56,4.08-10.31c2.72-2.75,6.21-4.13,10.48-4.13,3.97,0,7.28,1.38,9.93,4.13,2.64,2.75,3.97,6.19,3.97,10.31,0,1.17-.11,2.26-.33,3.28h-19.42Zm-.16-6.13h11.76c-.8-2.88-2.74-4.32-5.8-4.32s-5.16,1.44-5.96,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.94,15.22c3.76,0,6.93,1.28,9.52,3.83,2.59,2.55,3.88,5.65,3.88,9.3s-1.29,6.75-3.88,9.3c-2.59,2.55-5.76,3.83-9.52,3.83h-5.74v12.04h-8.75V15.22h14.5Zm0,18.05c1.35,0,2.46-.47,3.34-1.42,.88-.95,1.31-2.11,1.31-3.5s-.44-2.55-1.31-3.5c-.88-.95-1.99-1.42-3.34-1.42h-5.74v9.85h5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M270.66,26.16h8.21v27.35h-8.21v-2.57c-1.93,2.22-4.65,3.34-8.15,3.34s-6.69-1.39-9.25-4.18c-2.55-2.79-3.83-6.21-3.83-10.26s1.28-7.47,3.83-10.26c2.55-2.79,5.63-4.18,9.25-4.18s6.22,1.11,8.15,3.34v-2.57Zm-11.21,18.55c1.2,1.2,2.77,1.8,4.71,1.8s3.5-.6,4.71-1.8c1.2-1.2,1.8-2.83,1.8-4.87s-.6-3.67-1.8-4.87c-1.2-1.2-2.77-1.8-4.71-1.8s-3.5,.6-4.71,1.8c-1.2,1.2-1.8,2.83-1.8,4.87s.6,3.67,1.8,4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302.11,26.16h8.75l-9.36,26.53c-1.53,4.3-3.55,7.38-6.04,9.25-2.5,1.86-5.68,2.7-9.55,2.52v-7.66c1.9,0,3.36-.34,4.38-1.01,1.02-.68,1.84-1.85,2.46-3.53l-10.89-26.1h9.03l6.07,16.74,5.14-16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.24,53.51h-9.96l-6.46-11.08-6.45,11.08h-9.96l11.43-19.62-10.89-18.68h9.96l5.91,10.14,5.91-10.14h9.96l-10.89,18.68,11.43,19.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.43,22.4v1.1c0,.77-.04,1.52-.12,2.27v.02c-.05,.47-.11,.95-.19,1.42,0,.02,0,.04-.01,.06-.04,.24-.08,.47-.13,.71,0,.02,0,.03,0,.04-.1,.47-.21,.93-.33,1.39-.07,.24-.13,.47-.2,.7-.08,.25-.15,.5-.24,.74-.07,.19-.14,.38-.2,.57-.24,.62-.49,1.22-.78,1.81l-1.49-1.9h-18.77l2.16,2.88,5.71,10.31c-2.43,.9-5.05,1.39-7.78,1.39h-11.44V28.51h8.4c.14,0,.28,0,.42-.02,.05,0,.1,0,.15-.01,.09,0,.18-.02,.28-.04,.14-.02,.27-.05,.41-.08,.14-.03,.27-.07,.4-.11,.2-.06,.39-.13,.57-.21,.07-.03,.13-.06,.19-.09,.08-.04,.16-.08,.24-.12,.16-.08,.31-.18,.46-.28s.29-.21,.43-.32c.14-.11,.27-.24,.4-.36,1-1.01,1.63-2.4,1.63-3.93,0-3.08-2.49-5.57-5.57-5.57h-11.44V0h14.47C48.22,0,53.81,2.51,57.87,6.56c.38,.38,.75,.78,1.1,1.18,.21,.24,.42,.5,.62,.75,3.04,3.82,4.85,8.65,4.85,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.57,22.95v.55c0,1.69-.36,3.68-1.53,4.97-.77,.85-1.86,1.36-2.98,1.62-1.94,.46-5.85,.92-5.85,.92l-3.61,.59c0,.08,0-3.09,0-3.09h8.4c1.53,0,2.93-.62,3.93-1.63,1.01-1.01,1.63-2.39,1.63-3.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.43,22.4v1.1c0,.77-.04,1.53-.12,2.27v.02c-.05,.47-.11,.95-.19,1.42,0,.02,0,.04-.01,.06-.04,.23-.09,.47-.13,.7,0,.02,0,.03,0,.04-.1,.47-.21,.93-.33,1.39-.07,.23-.13,.46-.2,.7-.08,.25-.15,.49-.24,.74-.07,.19-.14,.38-.2,.57-.23,.62-.49,1.22-.78,1.81l-1.49-1.9h-6.35c3.04-7.45,2.97-15.27-.33-21.3-2.9-5.31-7.81-8.33-11.89-10.01,6.14,.04,11.69,2.53,15.71,6.56,.38,.38,.75,.78,1.1,1.18,.21,.24,.42,.5,.62,.74,3.04,3.82,4.85,8.66,4.85,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.82,44.5c-2.08,.77-4.31,1.24-6.64,1.36,1.81-1.41,3.43-2.93,4.87-4.54l1.76,3.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.31,2.9c7.47,3.71,12.46,11.83,12.31,20.18-.02,2.76-.48,5.52-1.46,8.09,.77-2.62,1.14-5.36,1.07-8.09-.06-8.25-4.85-16.03-11.92-20.18h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "70.98 47.46 87.66 68.81 72.43 68.81 61.35 54.05 39.7 66.56 39.66 66.58 39.64 66.59 39.7 66.51 55.84 46.71 53.05 43 45.68 33.17 59.81 33.17 61.25 35.01 63.27 37.6 77.47 20.17 92.79 20.17 70.98 47.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "92.79 20.17 70.98 47.46 89.75 20.17 92.79 20.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "66.52 59.36 72.99 67.88 85.72 67.88 79.06 59.36 66.52 59.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "39.7 66.51 53 46.41 45.68 33.17 55.84 46.71 39.7 66.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.75,24.94c.7-1.19,1.52-2.28,2.37-3.35,1.11,0,2.22,.03,3.32,.12,.36,.04,.71,.07,1.07,.13-.71,.11-1.12,.26-1.83,.3-.71,.04-1.61,.2-2.32,.2l.2-.09c-.84,1.03-1.82,1.78-2.8,2.69h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27.56,0V68.94H8.09V22.64H0V11.32c1.9-1.06,4.44-2.74,6.94-5.34,.41-.42,.79-.85,1.15-1.27C9.55,3.01,10.61,1.36,11.37,0H27.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.09 22.64 15.1 22.64 8.09 25.55 8.09 22.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M9.42,5.75c1.5-2.09,1.61-2.12,2.81-4.39,1.76-.04,2,0,3.76,.06,1.66,.08,3.33,.19,4.99,.43-1.66,.25-3.33,.35-4.99,.43-1.66,.06-1.8,.1-3.46,.06l.43-.25c-1.26,2.19-1.74,2.34-3.72,3.91l.18-.25Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo_new.5c6e78abb8bf32d7b8255be917e1cf78.svg";
export { ForwardRef as ReactComponent };